// extracted by mini-css-extract-plugin
export default {"pagination":"styles_pagination__sVsE4","loading":"styles_loading__HTMva"};